exports.inject = function(module) {
  module.factory('Conference', ['$resource', exports.factory]);   
};

exports.factory = function($resource) {
	// https://beta.brandedbridgeline.com/bridges/api/v1/conversation/?format=json
  return $resource('/bridges/api/v1/conversation/?limit=:limit&offset=:offset&format=json', { limit: '@limit', offset: '@offset' }, {
  // return $resource('/bridges/api/v1/conference/?limit=:limit&offset=:offset&format=json', { limit: '@limit', offset: '@offset' }, {
    query: {
      method: 'GET',
      isArray: false
    }
  });
};


/*****************
 ** WEBPACK FOOTER
 ** ./app/common/conference-service.js
 ** module id = 233
 ** module chunks = 0
 **/